export const normalizeMcpLoginRedirect = (value) => {
  const redirect = String(value || "").trim();
  return redirect.startsWith("/") && !redirect.startsWith("//") ?
    redirect : "/";
};
